import { render, staticRenderFns } from "./printedLicenses.vue?vue&type=template&id=06043d72&scoped=true&"
import script from "./printedLicenses.vue?vue&type=script&lang=js&"
export * from "./printedLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06043d72",
  null
  
)

export default component.exports